module.exports = __webpack_public_path__ + "img/chatgpt-green.c1f9dd34.svg";